import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SimuladorComponent } from './components/simulador/simulador.component';
import { TasaPreferencialComponent } from './components/tasaPreferencial/tasaPreferencial.component';
import { EstadoTasasComponent } from './components/estadoTasas/estadoTasas.component';

const routes: Routes = [
    {
        component: SimuladorComponent,
        path: "simulador",
        data: {
            title: 'Tasa y Simulación'
        },
    },
    {
        component: TasaPreferencialComponent,
        path: "tasa-preferencial",
        data: {
            title: 'Tasa Preferencial'
        },
    },
    {
        component: EstadoTasasComponent,
        path: "estado-tasas",
        data: {
            title: 'Estado de Tasa'
        },
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SimuladorRoutingModule { }